// Runtime config: reads from window.__RUNTIME_CONFIG__ (set by config.js).
// config.js is generated by entrypoint-config.sh — both in Docker and locally via scripts/dev.sh.
const config: Record<string, string> =
  typeof window !== 'undefined' && (window as any).__RUNTIME_CONFIG__
    ? (window as any).__RUNTIME_CONFIG__
    : {};

const environment = {
  production: config.ENV === 'production',
  env: config.ENV || 'development',

  graphqlUrl: config.GRAPHQL_URL ?? '',
  enrollGraphqlUrl: config.ENROLL_GRAPHQL_URL ?? '',
  enrollSubscriptionsUrl: config.ENROLLMENT_SUBSCRIPTIONS_URL ?? '',

  filesUrl: config.FILES_URL ?? '',
  cdnUrl: config.CDN_URL ?? '',
  dashboardUrl: (config.ONBOARDING_BASE_URL ?? '') + '/',
  advisorUrl: config.ADVISOR_URL ?? '',
  offersUrl: (config.DRUG_COST_URL ?? '') + '/',
  planFinderZ1Url: config.PLAN_FINDER_Z1_URL ?? '',
  quotingUrl: config.AGENT_QUOTING_URL ?? '',
  userFlowRestUrl: config.REST_URL ?? '',
  clientFileUploadUrl: config.CLIENT_FILE_UPLOAD_URL ?? '',
  consumerAiBaseUrl: config.CONSUMER_AI_BASE_URL ?? '',
  // b2b origin serving /api/brand/<key>
  brandApiUrl: config.BRAND_API_URL ?? '',

  planEngineAiUrl: config.PLAN_ENGINE_AI_URL ?? '',
  chatAiUrl: config.CHAT_AI_URL ?? '',
  chatAiWSUrl: config.CHAT_AI_WS_URL ?? '',

  posthogProjectToken: config.POSTHOG_PROJECT_TOKEN ?? '',
  posthogCrmProjectToken: config.POSTHOG_CRM_PROJECT_TOKEN ?? '',

  strapiUrl: config.STRAPI_URL ?? '',
  strapiToken: config.STRAPI_TOKEN ?? '',

  keycloakServer: config.KEYCLOAK_SERVER ?? '',
  keycloakRealm: config.KEYCLOAK_REALM ?? '',
  keycloakClientId: config.KEYCLOAK_CLIENT ?? '',
};

export { environment };
